<template>
  <div class="HEADER">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'blueprint-header',
};
</script>

<style lang="scss" scoped>
.HEADER {
  flex: none;
}
</style>
